import { render } from "./SecuredDoor.vue?vue&type=template&id=56c44e5a"
import script from "./SecuredDoor.vue?vue&type=script&lang=js"
export * from "./SecuredDoor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__